// extracted by mini-css-extract-plugin
export default {"modal":"PreviewTour_modal__O1ggy","tour":"PreviewTour_tour__tpjH5"};